import {graphql} from 'react-relay'

export const query = graphql`
  query HttpsConfigurationPageQuery {
    serverInfo {
      ...HttpsConfigurationPageDomainInfoFragment
      ...HttpsConfigurationPageServerUrlInfoFragment
    }
  }
`

export const nodesQuery = graphql`
  query HttpsConfigurationPageNodesQuery {
    nodes {
      count
    }
  }
`
